import { render, staticRenderFns } from "./VDocument.vue?vue&type=template&id=0294a8b8"
import script from "./VDocument.vue?vue&type=script&lang=js"
export * from "./VDocument.vue?vue&type=script&lang=js"
import style0 from "./VDocument.vue?vue&type=style&index=0&id=0294a8b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.33_cache-loader@4.1.0_webpack@4.47.0__css-load_7d97cc52897b1b5edd1ee8818c6a75fc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports